var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { PeekStack, PeekTypography, PeekToggleButton, PeekToggleButtonGroup, useTheme, } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "../messages.i18n";
import CustomAccordion from "./CustomAccordion";
import ProviderCheckbox from "./ProviderCheckbox";
import { PROVIDERS } from "./Providers";
export const ProvidersSelector = (_a) => {
    var { field, form, label } = _a, props = __rest(_a, ["field", "form", "label"]);
    const theme = useTheme();
    const intl = useIntl();
    const selectedProviders = Array.isArray(field.value) ? field.value : [];
    const handleProviderToggle = (provider, isSelected) => {
        var _a;
        const withoutProvider = selectedProviders.filter((item) => item.provider !== provider.id);
        if (isSelected) {
            form.setFieldValue(field.name, withoutProvider);
        }
        else {
            const defaultModelId = (_a = provider.models[0]) === null || _a === void 0 ? void 0 : _a.id;
            if (!defaultModelId) {
                form.setFieldValue(field.name, withoutProvider);
                return;
            }
            form.setFieldValue(field.name, [...withoutProvider, { provider: provider.id, model: defaultModelId }]);
        }
        form.setFieldTouched(field.name, true, true);
    };
    const handleModelSelect = (provider, modelId) => {
        const withoutProvider = selectedProviders.filter((item) => item.provider !== provider.id);
        form.setFieldValue(field.name, [...withoutProvider, { provider: provider.id, model: modelId }]);
        form.setFieldTouched(field.name, true, true);
    };
    return (React.createElement(PeekStack, Object.assign({ my: 1, spacing: 1.5 }, props),
        label && (React.createElement(PeekTypography, { variant: "h4", textTransform: "capitalize" }, label)),
        React.createElement(PeekStack, { spacing: 1 }, PROVIDERS.map((provider) => {
            const providerSelection = selectedProviders.find((item) => item.provider === provider.id);
            const activeModelId = providerSelection === null || providerSelection === void 0 ? void 0 : providerSelection.model;
            const isProviderSelected = Boolean(providerSelection);
            return (React.createElement(CustomAccordion, { key: provider.id, expanded: isProviderSelected, onChange: () => handleProviderToggle(provider, isProviderSelected), summaryContent: React.createElement(ProviderCheckbox, { label: provider.label, isChecked: isProviderSelected, onClick: () => handleProviderToggle(provider, isProviderSelected), dataTestId: `agent-model-provider-${provider.id}` }), detailsContent: React.createElement(PeekStack, { gap: 1, px: 1 },
                    React.createElement(PeekTypography, { variant: "body1", color: theme.palette.grey[400] }, intl.formatMessage(messages.aiDiscoverabilityModelSelectLabel)),
                    React.createElement(PeekToggleButtonGroup, { color: "primary", value: activeModelId !== null && activeModelId !== void 0 ? activeModelId : null, exclusive: true, orientation: "horizontal", onChange: (_event, value) => {
                            if (!value || typeof value !== "string") {
                                return;
                            }
                            handleModelSelect(provider, value);
                        }, sx: {
                            width: "100%",
                            overflow: "auto",
                            scrollbarWidth: "thin",
                            ".MuiButtonBase-root": {
                                whiteSpace: "nowrap !important",
                                height: 32,
                                fontSize: theme.typography.body1.fontSize,
                                borderColor: `${theme.palette.grey[200]} !important`,
                                boxShadow: "none !important",
                                borderWidth: 0.6,
                                "&:first-child": {
                                    borderTopLeftRadius: 8,
                                    borderBottomLeftRadius: 8,
                                },
                                "&:last-child": {
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                },
                                ":not(:first-child)": {
                                    marginLeft: -0.3,
                                },
                            },
                            ".Mui-selected": {
                                color: `${theme.palette.success.main} !important`,
                                borderColor: `${theme.palette.success.main} !important`,
                                backgroundColor: `${theme.palette.grey[50]} !important`,
                                zIndex: 2,
                            },
                        } }, provider.models.map((model) => (React.createElement(PeekToggleButton, { key: model.id, value: model.id, selected: activeModelId === model.id, disabled: !isProviderSelected, "data-testid": `agent-model-provider-${provider.id}-model-${model.id}`, sx: { width: "100%", fontSize: `${theme.typography.body1.fontSize}px !important` } }, model.label))))) }));
        }))));
};
export default ProvidersSelector;
